import { render, staticRenderFns } from "./rechargeAmount.vue?vue&type=template&id=50483d82&scoped=true&"
import script from "./rechargeAmount.vue?vue&type=script&lang=js&"
export * from "./rechargeAmount.vue?vue&type=script&lang=js&"
import style0 from "./rechargeAmount.vue?vue&type=style&index=0&id=50483d82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50483d82",
  null
  
)

export default component.exports